import React from 'react';
import { getAssetsUrl } from '@gik/core/utils/LinkUtils';
import { SignupCallout } from '@gik/auth';
import { ISignupCalloutProps } from '@gik/auth/components/Signup/SignupCallout';
import { useBemCN } from '@gik/core/utils/bemBlock';

export default function SignupCalloutGeneric() {
  const bem = useBemCN('signup-callout-generic');

  const values: ISignupCalloutProps = {
    mdBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutGeneric/fundraising.png`,
    mdDownBackgroundImageUrl: `${getAssetsUrl()}auth/img/SignupCalloutGeneric/fundraising-mobile.png`,
    title: 'Show your support',
    subtitle: 'Get notified of updates, sign up to help, send needed items, leave notes of encouragement and more.',
    imageUrl: `${getAssetsUrl()}auth/img/SignupCalloutGeneric/fundraising-example.svg`,
    imageAlt: 'Generic sign up modal image',
    ...bem(),
  };

  return <SignupCallout {...values} />;
}
